import { IconButton, Tooltip } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import ListCardViewControl from "../ListCardViewControl/ListCardViewControl";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import ViewListIcon from "@material-ui/icons/ViewList";
import { SearchField, SurveysHomeImgDefault, useStyles } from "./ViewControlMenu.styled";
import SearchIcon from "@material-ui/icons/Search";
import { Clear } from "@material-ui/icons";
import PropTypes from "prop-types";
import SurveyDefault from "../../assets/svg/surveys-default.svg";
import { theme as themeConfig } from "../../themes/themes";

const ViewControlMenu = ({
  identity,
  title,
  showCards,
  setShowCards,
  list,
  isApprovalsRequested,
  isAgent,
  isHistory,
  isRecurrent,
  toggleChecked,
  handleClickActions,
  anchorSelected,
  anchorEl,
  handlePreview,
  handleCloseActions,
  handleEditSurvey,
  handleEditEvent,
  handleEditEmail,
  handleSeeDetails,
  handleDownload,
  handleGuests,
  setAnchorEl,
  setAnchorSelected,
  setOpenDeleteModal,
  setOpenCloneSurveyModal,
  setOnlyAssigned,
  encriptParametersSurvey,
  setOpenActiveSurveyModal,
  setupdateData,
  triggerValue,
  setFormTrigger,
  setOpenResumeAnswer,
  handleReview,
  style,
  handleCreateSurveyFromTemplate,
  hideCategoryButtons,
  statistics,
  handleRatingDownload,
  kindOfList,
  showSearchBar,
  itsSurvey,
  isHomeSurvey,
}) => {
  const classes = useStyles({ identity: identity });
  const rSearch = useRef();
  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    if (Array.isArray(list) && list.length > 0) {
      setSearchData(list);
    }
  }, [list]);

  const handleSearch = (e) => {
    if (!e.target.value) {
      setSearchData(list);
      return;
    }
    setSearchData(
      list.filter((x) =>
        x.name.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  return (
    <Row style={{ margin: "0" }}>
      {title && (
        <Col md={8} className="pr-0 d-flex align-items-center">
          <h6 className={classes.titleOfList}>{title}</h6>
        </Col>
      )}
      {(identity === "lob-list" ||
        identity === "site-list" ||
        identity === "email-template-list") && (
          <Col
            md={title ? "4" : "12"}
            className="pr-2 d-flex justify-content-end"
          >
            {showSearchBar && (
              <SearchField>
                <SearchIcon
                  style={{ color: themeConfig.text.primary, marginLeft: "0.5rem" }}
                />
                <Form.Control
                  type="text"
                  placeholder="Search"
                  onChange={handleSearch}
                  ref={rSearch}
                />
                <Clear
                  style={{
                    right: "8rem",
                    color: themeConfig.neutral.gray[1700],
                    width: "1rem",
                    height: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    rSearch.current.value = "";
                    setSearchData(list);
                  }}
                />
              </SearchField>
            )}
            {!hideCategoryButtons && (
              <>
                <Tooltip title="View List">
                  <IconButton
                    style={{
                      borderRadius: "0px",
                      marginRight: "0px",
                      padding: "0px",
                      height: "1.7em",
                      marginTop: "0.5em",
                    }}
                    onClick={() => setShowCards(false)}
                  >
                    <ViewListIcon
                      style={{
                        color: showCards ? themeConfig.neutral.gray[400] : themeConfig.tabs.selected,
                        border: `1px solid ${themeConfig.neutral.gray[400]}`,
                        borderRight: "none",
                        padding: "7px",
                        fontSize: "1.7em",
                      }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="View Cards">
                  <IconButton
                    style={{
                      borderRadius: "0px",
                      marginLeft: "0px",
                      padding: "0px",
                      height: "1.7em",
                      marginTop: "0.5em",
                    }}
                    onClick={() => setShowCards(true)}
                  >
                    <ViewModuleIcon
                      style={{
                        color: showCards ? themeConfig.tabs.selected : themeConfig.neutral.gray[400],
                        border: `1px solid ${themeConfig.neutral.gray[400]}`,
                        padding: "7px",
                        fontSize: "1.7em",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </Col>
        )}
      <Row className={classes.rowContainList}>
        {Array.isArray(searchData) &&
          searchData.length > 0 &&
          searchData.map((item, index) => {
            return (
              <Col key={index} md={3} className={classes.colCardList}>
                <ListCardViewControl
                  identity={identity}
                  item={item}
                  isApprovalsRequested={isApprovalsRequested}
                  isAgent={isAgent}
                  isHistory={isHistory}
                  isRecurrent={isRecurrent}
                  toggleChecked={toggleChecked}
                  classes={classes}
                  handleClickActions={handleClickActions}
                  anchorSelected={anchorSelected}
                  anchorEl={anchorEl}
                  handleCloseActions={handleCloseActions}
                  handleEditSurvey={handleEditSurvey}
                  handleEditEvent={handleEditEvent}
                  handleEditEmail={handleEditEmail}
                  handleSeeDetails={handleSeeDetails}
                  handleGuests={handleGuests}
                  handleDownload={handleDownload}
                  setAnchorEl={setAnchorEl}
                  setAnchorSelected={setAnchorSelected}
                  setOpenDeleteModal={setOpenDeleteModal}
                  setOpenCloneSurveyModal={setOpenCloneSurveyModal}
                  setOnlyAssigned={setOnlyAssigned}
                  setOpenActiveSurveyModal={setOpenActiveSurveyModal}
                  encriptParametersSurvey={encriptParametersSurvey}
                  setupdateData={setupdateData}
                  triggerValue={triggerValue}
                  setFormTrigger={setFormTrigger}
                  setOpenResumeAnswer={setOpenResumeAnswer}
                  handleReview={handleReview}
                  style={style}
                  handleCreateSurveyFromTemplate={
                    handleCreateSurveyFromTemplate
                  }
                  statistics={statistics}
                  handleRatingDownload={handleRatingDownload}
                  handlePreview={handlePreview}
                  kindOfList={kindOfList}
                  itsSurvey={itsSurvey}
                />
              </Col>
            );
          })}
        {Array.isArray(searchData) && searchData.length < 3 && isHomeSurvey && (
          <>
            {[...Array(Math.max(0, 3 - searchData.length))].map((el, index) => (
              <Col key={index} md={3} className={classes.colCardList}>
                <SurveysHomeImgDefault key={el}>
                  <img className='' src={SurveyDefault} alt="Default surveys" />
                </SurveysHomeImgDefault>
              </Col>
            ))}
          </>
        )}
      </Row>
    </Row>
  );
};

export default ViewControlMenu;

ViewControlMenu.propTypes = {
  identity: PropTypes.string,
  title: PropTypes.string,
  list: PropTypes.array,
  isApprovalsRequested: PropTypes.bool,
  isAgent: PropTypes.bool,
  isHistory: PropTypes.bool,
  isRecurrent: PropTypes.bool,
  toggleChecked: PropTypes.func,
  handleClickActions: PropTypes.func,
  anchorSelected: PropTypes.number,
  anchorEl: PropTypes.number,
  handlePreview: PropTypes.func,
  handleCloseActions: PropTypes.func,
  handleEditSurvey: PropTypes.func,
  handleEditEvent: PropTypes.func,
  handleEditEmail: PropTypes.func,
  handleSeeDetails: PropTypes.func,
  handleDownload: PropTypes.func,
  handleGuests: PropTypes.func,
  setAnchorEl: PropTypes.func,
  setAnchorSelected: PropTypes.func,
  setOpenDeleteModal: PropTypes.func,
  setOpenCloneSurveyModal: PropTypes.func,
  setOnlyAssigned: PropTypes.func,
  encriptParametersSurvey: PropTypes.func,
  setOpenActiveSurveyModal: PropTypes.func,
  setupdateData: PropTypes.func,
  triggerValue: PropTypes.string,
  setFormTrigger: PropTypes.func,
  setOpenResumeAnswer: PropTypes.func,
  handleReview: PropTypes.func,
  style: PropTypes.object,
  handleCreateSurveyFromTemplate: PropTypes.func,
  hideCategoryButtons: PropTypes.bool,
  statistics: PropTypes.object,
  handleRatingDownload: PropTypes.func,
  kindOfList: PropTypes.string,
  showSearchBar: PropTypes.bool,
  isHomeSurvey: PropTypes.bool,
  showCards: PropTypes.bool,
  setShowCards: PropTypes.func,
  itsSurvey: PropTypes.bool,
};